const languageData = [
  // ==== Chinese locale hidden by request (REVERSIBLE) ====
  // To restore Chinese across the entire app (language switcher + every
  // localized field tab group), simply un-comment the object below.
  /*
  {
    languageId: 'chinese',
    code: 'zh',
    name: 'Chinese',
    icon: 'cn',
  },
  */
  {
    languageId: 'arabic',
    code: 'ar',
    name: 'Arabic',
    icon: 'sy',
  },
  {
    languageId: 'english',
    code: 'en',
    name: 'English',
    icon: 'us',
  },
];
export default languageData;
